module.exports = __webpack_public_path__ + "static/media/39.dbc2c63c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/39.jpg
// module id = 985
// module chunks = 0